var _g, _g2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesignUiBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#5294FF",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "design-and-development--02",
    d: "M29,2.5C29,2.776,28.776,3,28.5,3S28,2.776,28,2.5S28.224,2,28.5,2S29,2.224,29,2.5z M26.5,2C26.224,2,26,2.224,26,2.5S26.224,3,26.5,3S27,2.776,27,2.5S26.776,2,26.5,2z M24.5,2C24.224,2,24,2.224,24,2.5 S24.224,3,24.5,3S25,2.776,25,2.5S24.776,2,24.5,2z M10,14.36H4v-0.72h6V14.36z M14,11.36H4v-0.72h10V11.36z M14,8.36H4V7.64h10 V8.36z M31,31.36H1v-0.72h30V31.36z M31,28.36H1v-0.72h30V28.36z M31,25.36H1v-0.72h30V25.36z M31,22.36H1 c-0.199,0-0.36-0.161-0.36-0.36V1c0-0.199,0.161-0.36,0.36-0.36h30c0.199,0,0.36,0.161,0.36,0.36v21 C31.36,22.199,31.199,22.36,31,22.36z M1.36,21.64h29.28V4.36H1.36V21.64z M1.36,3.64h29.28V1.36H1.36V3.64z M24,15.36 c-2.404,0-4.36-1.956-4.36-4.36S21.596,6.64,24,6.64s4.36,1.956,4.36,4.36S26.404,15.36,24,15.36z M22.493,14.313 c0.46,0.209,0.97,0.327,1.507,0.327c2.007,0,3.64-1.633,3.64-3.64c0-0.539-0.117-1.051-0.328-1.511l-3.048,1.774L22.493,14.313z M20.688,9.489c-0.21,0.46-0.328,0.972-0.328,1.511c0,1.213,0.596,2.29,1.511,2.951l1.637-2.821L20.688,9.489z M21.052,8.867 L24,10.583l2.948-1.716C26.286,7.955,25.211,7.36,24,7.36S21.714,7.955,21.052,8.867z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle",
    style: {
      fill: "none"
    },
    width: 32,
    height: 32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignUiBlue);
export default __webpack_public_path__ + "static/media/designUIBlue.c32f2ba688a6550fa1debcc83ffafbcb.svg";
export { ForwardRef as ReactComponent };